const localisations = {
    fileUpload: {
        buttonText: "Choose File",
        emptyText: "Choose a file to upload..."        
    }
};

export default localisations;
